export default __webpack_public_path__ + "static/media/delele.171367a3.svg";